import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { appRoutes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { authInterceptorFn } from './core/interceptors/auth.interceptor.fn';
import { countryAccessInterceptorFn } from './core/interceptors/country-access.interceptor.fn';
import { TranslatedPaginatorIntl } from './core/services/language/translated-paginator-intl';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

function getDefaultLanguage(): string {

  const savedCode = localStorage.getItem('adminLanguage');
  if (savedCode === 'ru') {
    return 'world/standard/ru';
  }
  if (savedCode === 'en') {
    return 'world/standard/en';
  }

  const oldPath = localStorage.getItem('language');
  if (oldPath) {
    return oldPath;
  }

  return 'world/standard/ru';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideAnimations(),
    importProvidersFrom(MatSnackBarModule),
    { provide: MatPaginatorIntl, useClass: TranslatedPaginatorIntl },
    provideHttpClient(withInterceptors([authInterceptorFn, countryAccessInterceptorFn])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        defaultLanguage: getDefaultLanguage(),
      })
    ),
  ],
};
